// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"ef5bfdce","356":"1d5f8f6e","457":"990c9f00","585":"ee505440","809":"b091eaf9","838":"a9aa55b0","875":"528f89d9"}[chunkId] + ".chunk.js";
};